export const HAMS_BILLED_BY_EMAIL = 'mac/FETCH_HAMS_BILLED_BY_EMAIL';
export const LICENSE_BY_EMAIL = 'mac/FETCH_LICENSE_BY_EMAIL';
export const ARCHIVED_ACCOUNT_IDS = 'mac/FETCH_ARCHIVED_ACCOUNT_IDS';
export const ARCHIVED_LICENSE_IDS = 'mac/FETCH_ARCHIVED_LICENSE_IDS';
